if (!customElements.get('homecostume-offers')) {
  customElements.define('homecostume-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.copyHandler) return;
      this.copyHandler = async (event) => {
        const button = event.target.closest('[data-copy-code]');
        if (!button || !this.contains(button)) return;
        const code = button.dataset.copyCode;
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(code);
          status.textContent = `${code} copied. Use it at checkout.`;
        } catch {
          status.textContent = `Copy ${code} manually and use it at checkout.`;
        }
      };
      this.addEventListener('click', this.copyHandler);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.copyHandler);
      this.copyHandler = null;
    }
  });
}
